import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CLIENT_PORTAL } from "../constants";
import ReactGA from "react-ga4";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCheck } from "@fortawesome/free-solid-svg-icons";
const PRICING_PLAN = {
  SUBSCRIPTION: "subscription",
  BASIC: "basic",
  STANDARD: "standard",
  PREMIUM: "premium",
  BUNDLE: "bundle",
  ADD_ON: "add_on",
  SINGLE: "single",
};
const PRICING_TYPE = {
  ONE_TIME: "one_time",
  ONE_PHOTO: "one_photo",
  MONTHLY: "monthly",
  YEARLY: "yearly",
};

// 1 condo = 25 photos conversion rate
const CONDO_TO_PHOTO_RATIO = 25;

const currencyMap = {
  en: "USD",
  ja: "JPY",
  // add more language and currency pairs as needed
};
const data = [
  {
    title: "pricing_pay_as_you_go",
    subTitle: "pricing_pay_as_you_go_sub",
    subTitleDes: "pricing_pay_as_you_go_sub_des",
    description: "pricing_pay_as_you_go_des",
    credit: 0,
    usdPrice: 0,
    yenPrice: 0,
    plan: PRICING_PLAN.BUNDLE,
    type: PRICING_TYPE.MONTHLY,
    numberOfPhotos: 0,
    singerPurchase: true,
    features: ["1_month_storage", "10_item_limited", "10M_limited"],
  },

  {
    title: "pricing_100_standard",
    subTitle: "pricing_100_standard_sub",
    subTitleDes: "pricing_100_standard_sub_des",
    description: "pricing_100_standard_des",
    credit: 120,
    usdPrice: 60,
    yenPrice: 7500,
    plan: PRICING_PLAN.STANDARD,
    type: PRICING_TYPE.MONTHLY,
    numberOfPhotos: 100,
    features: ["3_month_storage", "100_item_limited", "10M_limited"],
  },
  {
    title: "pricing_200_standard",
    subTitle: "pricing_200_standard_sub",
    subTitleDes: "pricing_200_standard_sub_des",
    description: "pricing_200_standard_des",
    credit: 240,
    usdPrice: 100,
    yenPrice: 12500,
    plan: PRICING_PLAN.STANDARD,
    type: PRICING_TYPE.MONTHLY,
    numberOfPhotos: 200,
    // tag: "recommended",
    features: ["3_month_storage", "100_item_limited", "10M_limited"],
  },
  {
    title: "pricing_400_standard",
    subTitle: "pricing_400_standard_sub",
    subTitleDes: "pricing_400_standard_sub_des",
    description: "pricing_400_standard_des",
    credit: 480,
    usdPrice: 160,
    yenPrice: 20000,
    plan: PRICING_PLAN.STANDARD,
    type: PRICING_TYPE.MONTHLY,
    numberOfPhotos: 400,
    features: ["3_month_storage", "100_item_limited", "10M_limited"],
  },
  {
    title: "pricing_800_standard",
    subTitle: "pricing_800_standard_sub",
    subTitleDes: "pricing_800_standard_sub_des",
    description: "pricing_800_standard_des",
    credit: 960,
    usdPrice: 200,
    yenPrice: 25000,
    plan: PRICING_PLAN.STANDARD,
    type: PRICING_TYPE.MONTHLY,
    numberOfPhotos: 800,
    features: ["3_month_storage", "100_item_limited", "10M_limited"],
  },

  {
    title: "pricing_custom",
    subTitle: "pricing_custom_sub",
    subTitleDes: "pricing_custom_sub_des",
    description: "pricing_custom_des",
    credit: 0,
    usdPrice: 0,
    yenPrice: 0,
    plan: PRICING_PLAN.PREMIUM,
    type: PRICING_TYPE.MONTHLY,
    numberOfPhotos: 20001,
  },
  {
    title: "pricing_30_bundles",
    subTitle: "pricing_30_bundles_sub",
    subTitleDes: "pricing_30_bundles_sub_des",
    description: "pricing_30_bundles_des",
    credit: 36,
    usdPrice: 31.5,
    yenPrice: 3938,
    plan: PRICING_PLAN.BUNDLE,
    type: PRICING_TYPE.ONE_TIME,
    numberOfPhotos: 36,
    tag: "save",
  },
  {
    title: "pricing_50_bundles",
    subTitle: "pricing_50_bundles_sub",
    subTitleDes: "pricing_50_bundles_sub_des",
    description: "pricing_50_bundles_des",
    credit: 60,
    usdPrice: 50,
    yenPrice: 6250,
    plan: PRICING_PLAN.BUNDLE,
    type: PRICING_TYPE.ONE_TIME,
    numberOfPhotos: 60,
    tag: "save",
  },
  {
    title: "pricing_100_bundles",
    subTitle: "pricing_100_bundles_sub",
    subTitleDes: "pricing_100_bundles_sub_des",
    description: "pricing_100_bundles_des",
    credit: 120,
    usdPrice: 80,
    yenPrice: 10000,
    plan: PRICING_PLAN.BUNDLE,
    type: PRICING_TYPE.ONE_TIME,
    numberOfPhotos: 120,
    tag: "save",
  },
  {
    title: "pricing_basic_storage_service",
    subTitle: "pricing_basic_storage_service_sub",
    subTitleDes: "pricing_basic_storage_service_sub_des",
    description: "pricing_basic_storage_service_des",
    credit: 0,
    usdPrice: 100,
    yenPrice: 12500,
    features: ["easy_setting", "multiple_process"],
    plan: PRICING_PLAN.ADD_ON,
    type: PRICING_TYPE.MONTHLY,
    // tag: "new",
  },
  // {
  //   title: "pricing_pro_team_service",
  //   subTitle: "pricing_pro_team_service_sub",
  //   subTitleDes: "pricing_pro_team_service_sub_des",
  //   description: "pricing_pro_team_service_des",
  //   credit: 0,
  //   usdPrice: 0.3,
  //   yenPrice: 40,
  //   plan: PRICING_PLAN.ADD_ON,
  //   type: PRICING_TYPE.ONE_PHOTO,
  //   singerPurchase: true,
  // },
  // {
  //   title: "pricing_blur_service",
  //   subTitle: "pricing_blur_service_sub",
  //   subTitleDes: "pricing_blur_service_sub_des",
  //   description: "pricing_blur_service_des",
  //   credit: 0,
  //   usdPrice: 0.4,
  //   yenPrice: 50,
  //   plan: PRICING_PLAN.ADD_ON,
  //   type: PRICING_TYPE.ONE_PHOTO,
  //   singerPurchase: true,
  // },
  {
    title: "pricing_storage_service",
    subTitle: "pricing_storage_service_sub",
    subTitleDes: "pricing_storage_service_sub_des",
    description: "pricing_storage_service_des",
    credit: 0,
    usdPrice: 200,
    yenPrice: 25000,
    plan: PRICING_PLAN.ADD_ON,
    type: PRICING_TYPE.MONTHLY,

    features: ["easy_setting", "multiple_process"],
    // tag: "new",
  },
];

const features = [
  // {
  //   title: "storage_service_1",
  //   service: "pricing_storage_service",
  // },
  // {
  //   title: "storage_service_2",
  //   service: "pricing_storage_service",
  // },
  // {
  //   title: "storage_service_3",
  //   service: "pricing_storage_service",
  // },
  // {
  //   title: "storage_service_4",
  //   service: "pricing_storage_service",
  // },
  {
    title: "free_credits",
  },
  {
    title: "free_watermark",
  },
  {
    title: "free_file_resolution",
  },
  // {
  //   title: "10_item_limited",
  // },
  // {
  //   title: "50_item_limited",
  // },
  // {
  //   title: "100_item_limited",
  // },
  {
    title: "editor_tool_supported",
  },
  // {
  //   title: "1_week_storage",
  // },
  // {
  //   title: "1_month_storage",
  // },
  // {
  //   title: "3_month_storage",
  // },
  {
    title: "credit_rollover",
  },
  {
    title: "free_support",
  },

  {
    title: "keep_same_rate",
  },
  {
    title: "cancel_anytime",
  },
];

export const Pricing = (props) => {
  const { t, i18n } = useTranslation();
  const { initialTab } = props;
  const [currency, setCurrency] = useState(currencyMap[i18n.language]);
  const [planType, setPlanType] = useState(initialTab || PRICING_PLAN.BUNDLE);
  const [showCalculatorPopup, setShowCalculatorPopup] = useState(false);

  // New state variables for filtering
  const [photoCount, setPhotoCount] = useState(0);
  const [condoCount, setCondoCount] = useState(0);

  // New state variable for conversion rate
  const [conversionRate, setConversionRate] = useState(CONDO_TO_PHOTO_RATIO);

  // Find max photo count from data for slider max value
  const maxPhotos = 10001;
  const maxCondos = Math.ceil(maxPhotos / conversionRate);
  //find the data plan with current photo count
  const suggestedPlan =
    data.find((item) => item.numberOfPhotos >= photoCount) ?? data[0];

  // Convert between condos and photos
  const photosToCondos = (photos) => Math.ceil(photos / conversionRate);
  const condosToPhotos = (condos) => condos * conversionRate;
  const planToCondos = (plan) => {
    switch (plan) {
      case PRICING_PLAN.BASIC:
        return 0;
      case PRICING_PLAN.STANDARD:
        return 4;
      case PRICING_PLAN.PREMIUM:
        return 400;
      default:
        return 0;
    }
  };
  // Handle photo slider value change
  const handlePhotoSliderChange = (e) => {
    const value = parseInt(e.target.value);
    setPhotoCount(value);
    const condos = photosToCondos(value);
    setCondoCount(condos);
  };

  // Handle condo slider value change
  const handleCondoSliderChange = (e) => {
    const value = parseInt(e.target.value);
    setCondoCount(value);
    setPhotoCount(condosToPhotos(value));
  };

  // Format numbers with commas for better readability
  const formatNumber = (number) => {
    return number.toLocaleString();
  };

  const renderRibbonWithTag = (tag, item) => {
    switch (tag) {
      case "best_seller":
        return (
          <div className="ribbon ribbon_best_seller">
            {t(`pricing_best_seller`)}
          </div>
        );
      case "recommended":
        return (
          <div className="ribbon ribbon_recommended">
            {t(`pricing_recommended`)}
          </div>
        );
      case "save":
        const savedPercentage = Number(
          ((item.credit - item.usdPrice) / item.credit) * 100,
        ).toFixed(1);
        return (
          <div className="ribbon ribbon_save">
            <span>{savedPercentage}%</span>
            {t(`pricing_save`)}
          </div>
        );
      case "new":
        return <div className="ribbon ribbon_new">{t(`pricing_new`)} </div>;
      default:
        return null;
    }
  };
  const renderPrice = (plan) => {
    if (plan.title === "pricing_pay_as_you_go") {
      return (
        <div className="plan_fee" style={{ opacity: "1" }}>
          {t(`pricing_free`)}
        </div>
      );
    }
    if (plan.title === "pricing_custom") {
      return (
        <div className="plan_fee">
          XX<div className="payment_type">{t(`price_monthly`)}</div>
        </div>
      );
    }
    return (
      <div className="plan_fee">
        {currency === "USD" ? "$" : "¥"}
        {currency === "USD"
          ? plan.usdPrice.toLocaleString("en-US")
          : plan.yenPrice.toLocaleString("ja-JP")}
        {plan.type === PRICING_TYPE.MONTHLY && (
          <div className="payment_type">{t(`price_monthly`)}</div>
        )}
        {plan.type === PRICING_TYPE.ONE_PHOTO && (
          <div className="payment_type">{t(`price_photo`)}</div>
        )}
      </div>
    );
  };
  const handleActionClick = (planName) => {
    window.open(CLIENT_PORTAL, "_blank");
    ReactGA.event({
      category: "Landing Page",
      action: "Click",
      label: "Go detail of plan" + planName,
    });
  };
  const renderAction = (plan) => {
    if (plan.title === "pricing_pay_as_you_go") {
      return (
        <button
          className="plan_action btn btn-primary"
          onClick={() => handleActionClick(plan.title)}
        >
          {t(`start_now`)}
        </button>
      );
    }
    if (plan.title === "pricing_custom") {
      return (
        <a href="./#contact" className="plan_action btn btn-primary">
          {t(`pricing_call_now`)}
        </a>
      );
    }
    if (plan.type === PRICING_TYPE.ONE_TIME) {
      return (
        <button
          className="plan_action btn btn-primary"
          onClick={() => handleActionClick(plan.title)}
        >
          {t(`pricing_buy_now`)}
        </button>
      );
    }
    if (plan.type === PRICING_TYPE.ONE_PHOTO) {
      return (
        <button
          className="plan_action btn btn-primary"
          onClick={() => handleActionClick(plan.title)}
        >
          {t(`add_now`)}
        </button>
      );
    }
    return (
      <button
        className="plan_action btn btn-primary"
        onClick={() => handleActionClick(plan.title)}
      >
        {t(`pricing_subscribe`)}
      </button>
    );
  };
  const renderPlanCredit = (item) => {
    if (item.plan === PRICING_PLAN.ADD_ON && item.credit === 0) {
      return t("addon");
    }
    switch (item.title) {
      case "pricing_pay_as_you_go":
        return t("free");
      case "pricing_custom":
        return t("contact_us");
      default:
        return `+ ${item.credit.toLocaleString()} ${t("service_credit")}`;
    }
  };
  const renderPlanFeature = (item) => {
    return item.features?.map((feature, index) => (
      <div
        key={index}
        className="pricing_item_feature"
        style={{
          fontSize: "14px",
        }}
      >
        <FontAwesomeIcon
          style={{ marginRight: "5px" }}
          icon={faCheck}
          color={"green"}
        />
        {t(feature)}
      </div>
    ));
  };

  const renderPriceItem = (index, item) => {
    return (
      <div key={index} className="col-12 col-sm-6 col-md-4 pricing-item-border">
        <div
          className={
            `pricing-item` +
            ([PRICING_PLAN.ADD_ON, PRICING_PLAN.BUNDLE].includes(item.plan)
              ? " pricing-item-small"
              : "")
          }
        >
          <div className="plan_title">{t(item.title)}</div>
          <div
            className="plan_sub_des"
            style={{ fontSize: "14px" }}
            dangerouslySetInnerHTML={{
              __html: t(item.subTitle).replace(/\n/g, "<br>"),
            }}
          ></div>
          {/* <div className="plan_sub">{t(item.subTitleDes)}</div> */}

          {item.tag && renderRibbonWithTag(item.tag, item)}
          {renderPrice(item)}
          <div className="plan_credit">
            {renderPlanCredit(item)}
            <div className="plan_des"> {t(item.description)}</div>
          </div>
          {![PRICING_PLAN.BUNDLE].includes(item.plan) && (
            <div className="plan_features">{renderPlanFeature(item)}</div>
          )}

          {renderAction(item)}
        </div>
      </div>
    );
  };

  useEffect(() => {
    setCurrency(currencyMap[i18n.language]);
  }, [i18n.language]);

  // Handle initialTab prop to set the pricing plan type
  useEffect(() => {
    if (initialTab) {
      setPlanType(initialTab);
    }
  }, [initialTab]);
  return (
    <section id="pricing">
      <div className="contInner">
        <h2 className="hdg_ttl02">
          <div>
            <span>{t(`pricing_title`)}</span>
          </div>
        </h2>
        <div className="txt">
          {t("pricing_des")}
          <br />
          {t("pricing_des_2")}
          <p className="txt_note">{t("pricing_note")}</p>
        </div>
        {/* <div className="single-purchase-container">
          <div className="single-purchase-header">
            <h3>{t("pricing_single_purchase")}</h3>

            <div className="txt">{t("pricing_single_purchase_des")}</div>
          </div>
          <div className=" basic_single_purchase">
            <div className="row pricing-row">
              {renderPriceItem(-1, data[0])}

              <div
                className="col col-sm-12 col-md-2 pricing-item-border"
                style={{
                  paddingTop: "170px",
                }}
              >
                <h3>{t("adding_service")}</h3>
              </div>
              <div
                className="col col-sm-12 col-md-5 pricing-item-border"
                style={{
                  paddingTop: "120px",
                }}
              >
                {data
                  .filter(
                    (item) =>
                      item.plan === PRICING_PLAN.ADD_ON &&
                      item.type === PRICING_TYPE.ONE_PHOTO
                  )
                  .map((item, index) => renderAddOnServices(item, index))}
              </div>
            </div>
          </div>
          <div className="see_bundle">
            <span>{t(`pricing_see_bundle_des`)}</span>
            <div
              className="btn"
              onClick={() => {
                ReactGA.send({
                  hitType: "pageview",
                  page: "pricing",
                  title: "See bundle Details",
                });
                setShowBundlePrice(!showBundlePrice);
              }}
            >
              <span>{t(`pricing_see_bundle_btn`)}</span>
            </div>
          </div>
          {showBundlePrice && (
            <div className="price_plans">
              <div className="row pricing-row g-5">
                {data
                  .filter(
                    (item) => item.plan === PRICING_PLAN.BUNDLE // Filter by photo count
                  )
                  .map((item, index) => renderPriceItem(index, item))}
              </div>
            </div>
          )}
        </div> */}

        <div className="subscription-purchase-container">
          {/* <div className="single-purchase-header">
            <div className="see_calculator">
              {t("pricing_see_calculator_des")}
              <div
                className="btn"
                onClick={() => {
                  ReactGA.send({
                    hitType: "pageview",
                    page: "pricing",
                    title: "Open Plan Calculator",
                  });
                  setShowCalculatorPopup(true);
                }}
              >
                <span>{t(`pricing_see_calculator_btn`)}</span>
              </div>
            </div>
          </div> */}

          <div className="filter row">
            <div className="col col-sm-12 pricing_filter">
              {/* First row - Main filter */}
              <div className="pricing_filter_group">
                {[
                  PRICING_PLAN.BUNDLE,
                  PRICING_PLAN.SUBSCRIPTION,
                  PRICING_PLAN.ADD_ON,
                ].map((plan, index) => (
                  <div
                    key={index}
                    className={`pricing_filter_item ${
                      plan === planType ? "active" : ""
                    }`}
                    onClick={() => {
                      setPlanType(plan);
                      const condos = planToCondos(plan);
                      setCondoCount(condos);
                      setPhotoCount(condosToPhotos(condos));
                    }}
                  >
                    <div className="filter_main_text">
                      {t(`pricing_cate_${plan}`)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="price_plans">
            {(() => {
              const filteredItems = data.filter((item) => {
                if (planType === PRICING_PLAN.SUBSCRIPTION) {
                  return [
                    PRICING_PLAN.BASIC,
                    PRICING_PLAN.STANDARD,
                    PRICING_PLAN.PREMIUM,
                  ].includes(item.plan);
                }
                return item.plan === planType;
              });

              return (
                <div
                  className={`row pricing-row ${
                    filteredItems.length < 3 ? "pricing-row-centered" : ""
                  }`}
                  style={{
                    justifyContent:
                      filteredItems.length < 3 ? "center" : "flex-start",
                  }}
                >
                  {filteredItems.map((item, index) =>
                    renderPriceItem(index, item),
                  )}
                </div>
              );
            })()}
          </div>
          {/* Subscription calculation note */}
          {planType === PRICING_PLAN.SUBSCRIPTION && (
            <div className="subscription-calculation-note">
              {t("pricing_subscription_calculation_note")}
            </div>
          )}
          {planType !== PRICING_PLAN.ADD_ON && (
            <div className="price-plan-feature">
              <div className="plan-features row">
                <div className="filter-header">
                  <h3 style={{ marginTop: "0px" }}>
                    {t("default_plan_feature")}
                  </h3>
                  {/* <p>{t("default_plan_feature_des")}</p> */}
                </div>
                {features
                  //.filter((feature) => feature.types.includes(planType))
                  // .sort((a, b) => t(a.title).length - t(b.title).length)
                  .map((feature, index) => (
                    <div
                      key={index}
                      className={"pricing_item_feature  col-sm-12 "}
                    >
                      <FontAwesomeIcon
                        style={{ marginRight: "5px" }}
                        icon={faCircleCheck}
                        color={"#3678f7"}
                      />
                      {t(feature.title)}
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>

        {/* ADD-ON Section */}

        {/* <div
          className="add-on-section single-purchase-container"
          style={{ marginTop: "50px" }}
        >
          <h3 className="">{t("pricing_add_ons")}</h3>
          <div className="txt">{t("pricing_add_ons_des")}</div>
          <div className="row">
            {data
              .filter(
                (item) =>
                  item.plan === PRICING_PLAN.ADD_ON &&
                  item.type !== PRICING_TYPE.ONE_PHOTO
              )
              .map((item, index) => renderAddOnServices(item, index))}
          </div>
        </div> */}

        {/* Plan Calculator Popup */}
        {showCalculatorPopup && (
          <div
            className="calculator-popup-overlay"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
            onClick={() => setShowCalculatorPopup(false)}
          >
            <div
              className="calculator-popup-content"
              style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "30px",
                maxWidth: "900px",
                width: "100%",
                maxHeight: "90vh",
                overflow: "auto",
                position: "relative",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close button */}
              <button
                onClick={() => setShowCalculatorPopup(false)}
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "15px",
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "#666",
                  padding: "5px",
                }}
              >
                ×
              </button>

              {/* Popup content */}
              <div className="filter-header" style={{ marginBottom: "30px" }}>
                <h3 style={{ marginTop: "0px", fontSize: "24px" }}>
                  {t("find_your_plan")}
                </h3>
                <p>{t("find_your_plan_des")}</p>
              </div>

              {/* Two-column layout */}
              <div style={{ display: "flex", gap: "30px", flexWrap: "wrap" }}>
                {/* Left column - Sliders */}
                <div style={{ flex: "1", minWidth: "300px" }}>
                  {/* Condo slider */}
                  <div
                    className="slider-container"
                    style={{ marginBottom: "30px" }}
                  >
                    <div
                      className="slider-label"
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ fontWeight: "500", fontSize: "16px" }}>
                        {t("condos_needed")}:{" "}
                        <strong>{formatNumber(condoCount)}</strong>
                      </span>
                    </div>

                    <input
                      type="range"
                      min="1"
                      max={maxCondos}
                      value={condoCount}
                      onChange={handleCondoSliderChange}
                      className="slider"
                      style={{
                        width: "100%",
                        height: "10px",
                        borderRadius: "5px",
                        background:
                          "linear-gradient(to right, #3678f7, #64a1ff)",
                        outline: "none",
                        cursor: "pointer",
                      }}
                    />

                    <div
                      className="slider-labels"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "8px",
                        fontSize: "12px",
                        color: "#777",
                      }}
                    >
                      <span>1</span>
                      <span>{formatNumber(Math.round(maxCondos / 4))}</span>
                      <span>{formatNumber(Math.round(maxCondos / 2))}</span>
                      <span>
                        {formatNumber(Math.round((maxCondos * 3) / 4))}
                      </span>
                      <span>&gt; {formatNumber(maxCondos - 1)}</span>
                    </div>
                  </div>

                  {/* Photo slider */}
                  <div className="slider-container">
                    <div
                      className="slider-label"
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ fontWeight: "500", fontSize: "16px" }}>
                        {t("photos_needed")}:{" "}
                        <strong>{formatNumber(photoCount)}</strong>
                      </span>
                    </div>

                    <input
                      type="range"
                      min="0"
                      max={maxPhotos}
                      value={photoCount}
                      onChange={handlePhotoSliderChange}
                      className="slider"
                      style={{
                        width: "100%",
                        height: "10px",
                        borderRadius: "5px",
                        background:
                          "linear-gradient(to right, #3678f7, #64a1ff)",
                        outline: "none",
                        cursor: "pointer",
                      }}
                    />

                    <div
                      className="slider-labels"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "8px",
                        fontSize: "12px",
                        color: "#777",
                      }}
                    >
                      <span>1</span>
                      <span>{formatNumber(Math.round(maxPhotos / 4))}</span>
                      <span>{formatNumber(Math.round(maxPhotos / 2))}</span>
                      <span>
                        {formatNumber(Math.round((maxPhotos * 3) / 4))}
                      </span>
                      <span>&gt; {formatNumber(maxPhotos - 1)}</span>
                    </div>
                  </div>
                </div>

                {/* Right column - Info */}
                <div style={{ flex: "1", minWidth: "300px" }}>
                  {/* Conversion rate box */}
                  <div
                    style={{
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      padding: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "15px",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: "#3678f7",
                          color: "white",
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "12px",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        i
                      </div>
                      <div style={{ fontSize: "16px", fontWeight: "500" }}>
                        {t("pricing_condo_ratio")}{" "}
                        <input
                          type="number"
                          min="1"
                          max="100"
                          value={conversionRate}
                          onChange={(e) => {
                            const newRate = parseInt(e.target.value) || 1;
                            setConversionRate(newRate);
                            setPhotoCount(condoCount * newRate);
                          }}
                          style={{
                            width: "50px",
                            padding: "4px",
                            margin: "0 4px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            textAlign: "center",
                          }}
                        />{" "}
                        {t("pricing_photos")}
                      </div>
                    </div>
                  </div>

                  {/* Suggested plan box */}
                  <div
                    style={{
                      backgroundColor: "#e6f0ff",
                      borderLeft: "4px solid #3678f7",
                      borderRadius: "8px",
                      padding: "20px",
                    }}
                  >
                    <h4 style={{ margin: "0 0 15px 0", fontSize: "18px" }}>
                      {t("pricing_suggested_plan")}
                    </h4>
                    <div style={{ marginBottom: "15px" }}>
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#3678f7",
                          fontSize: "20px",
                        }}
                      >
                        {t(`${suggestedPlan.title}`)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
